import React from 'react'
import cards from '../images/cards.png';

function RateCard({ carditems }) {
    // console.log(carditems);
    return (
        <div className="rate-card mb-3 mt-3">
            {carditems.length > 0 ?
                <div className="table-responsive">
                    <table className="table table-bordered table-hover table-striped table-sm mb-0">
                        <thead>
                            <tr>
                                <th>Transaction type</th>
                                <th className="text-left">Rate</th>
                            </tr>
                        </thead>
                        <tbody>

                            {carditems.map((item, i) => {
                                return (
                                    <tr key={i}>
                                        <td>
                                            <span className="card-text">
                                                {item.name}
                                                {item.logos === 1 ? <img src={cards} className="img-fluid d-none d-md-block" alt="cards" /> : ''}
                                            </span>
                                        </td>
                                        <td className="text-left">{item.value}</td>
                                    </tr>);
                            })}
                        </tbody>
                    </table>
                </div>
                : ''}
        </div>
    )
}

export default RateCard
